import React, { useState, useRef, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import samplePDF from '../../assets/SampleCreditReport.pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

const PDFViewer = ({ buttonClass }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [width, setWidth] = useState(null);
  const containerRef = useRef(null);

  const toggleModal = () => setIsOpen(!isOpen);
  const onDocumentLoadSuccess = ({ numPages }) => setNumPages(numPages);

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.offsetWidth - 40); // Adjust width to account for padding/border
      }
    };

    if (isOpen) {
      handleResize();
      window.addEventListener('resize', handleResize);
    }

    return () => window.removeEventListener('resize', handleResize);
  }, [isOpen]);

  return (
    <>
      <button onClick={toggleModal} className={buttonClass}>📄 View PDF</button>

      {isOpen && (
        <div style={styles.modalOverlay} onClick={toggleModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button style={styles.closeBtn} onClick={toggleModal}>✖</button>
            <div style={styles.pdfContainer} ref={containerRef}>
              <Document
                file={samplePDF}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                {Array.from(new Array(numPages), (_, index) => (
                  <div key={`page_${index + 1}`} style={styles.pageBorder}>
                    <Page
                      pageNumber={index + 1}
                      width={width || 600}
                    />
                  </div>
                ))}
              </Document>
            </div>
            <a href={samplePDF} download="CreditReport.pdf" style={styles.downloadLink}>
              Download PDF
            </a>
          </div>
        </div>
      )}
    </>
  );
};

const styles = {
  openBtn: {
    padding: '8px 16px',
    cursor: 'pointer',
    backgroundColor: '#007BFF',
    color: 'white',
    borderRadius: '4px',
    border: 'none',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
  modalContent: {
    position: 'relative',
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '15px',
    width: '80vw',
    height: '90vh',
    overflow: 'auto',
  },
	closeBtn: {
	  position: 'sticky',
	  top: '10px',
	  float: 'right', // ensures correct alignment
	  border: 'none',
	  background: 'none',
	  fontSize: '24px',
	  cursor: 'pointer',
	  zIndex: 1000,
	  marginRight: '15px', // explicitly sets 15px spacing from right
	},
  pdfContainer: {
    width: '100%',
    overflowY: 'auto',
  },
  pageBorder: {
    border: '1px solid #ccc',
    marginBottom: '15px',
    borderRadius: '4px',
    padding: '10px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    backgroundColor: '#fff',
  },
  downloadLink: {
    display: 'inline-block',
    margin: '10px auto',
    padding: '8px 16px',
    backgroundColor: '#007BFF',
    color: 'white',
    borderRadius: '4px',
    textDecoration: 'none',
    cursor: 'pointer',
    textAlign: 'center',
  },
};

export default PDFViewer;
